<template>
  <div class="popup" v-cloak v-if="noticeShow">
      <div class="content" id="noticeRealTime">
            <div class="title">
                {{$t('language.paySystem.Notice')}}
                 <div class="icon white-close dialog-close" @click="noticeShow=false"></div>
            </div>
            <div class="notice-body">
                   <div class="notice-info">
                    {{$t('language.cloudBackup.taskRuning')}}
                   </div>
                   <div class="realtime-notice-bottom">
                        <button style="width:110Px;marginRight:10Px;float:right;" @click.stop="runTasK()"> {{$t('language.common.ok')}}</button>
                   </div>
            </div>
      </div>
  </div>
</template>

<script>
export default {
    data:function(){
        return{
            noticeShow:false,
            isSure:false
        }
    },
    methods: {
        runTasK(){
           this.noticeShow=false;
        }

    },
    
}
</script>

<style>
#noticeRealTime{
    width: 550Px;
    height: 220Px;
}
.notice-body{
    width: 100%;
    height: 180Px;
    padding: 20Px 10Px 10Px 20Px;
    box-sizing: border-box;
}
.notice-info{
    width: 100%;
    height:100Px;
    float: left;
}
.realtime-notice-bottom{
    width: 528Px;
    height: 40Px;
    float: left;

}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_rename_notice_popup.vue